import ReportFlavorStructure from './ReportFlavorStructure';
export default ReportFlavorStructure;